import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { UrlHelper } from '../url-helper';

@Injectable({
    providedIn: 'root'
})
export class SearchService {
    constructor(
        private readonly http: HttpClient,
        private readonly urlHelper: UrlHelper
    ) { }

    public find(text: string): Observable<{ key: string, items: { id: string, label: string }[] }[]> {
        return this.http.get<{ key: string, items: any[] }[]>(this.urlHelper.of(`search/${text}`))
            .pipe(
                map(result => {
                    if (result) {
                        return result.map(x => ({ key: x.key, items: x.items.map(item => ({ id: item.id, label: item.label })) }));
                    }
                    return [];
                }));
    }
}
